/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { AsyncResult } from '@msdyn365-commerce/retail-proxy';

/**
 * FetchChooseYourFoundationDatabase Input Action
 */
export class FetchChooseYourFoundationDatabaseInput implements Msdyn365.IActionInput {
    public jsonSrc: string;
    // Construct the input needed to run the action
    constructor(jsonSrc: string) {
        this.jsonSrc = jsonSrc;
    }

    // Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `ChooseYourFoundationDatabase`;
    public getCacheObjectType = () => 'ChooseYourFoundationDatabase';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

// Create a data model here or import one to capture the response of the action
export interface IFetchChooseYourFoundationDatabaseData {
    text: string;
    jsonSrc: string;
}

export interface IDatabaseRow {
    mattressVariantReqId: string;
    baseVariantReqIdList: string[];
    recommendedBaseVariantReqId: string;
    splitVariantReqIdList: string[];
}

export interface foo {
    database: AsyncResult<IDatabaseRow[]>;
}

/**
 * Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext<IFetchChooseYourFoundationDatabaseData>): Msdyn365.IActionInput => {
    return new FetchChooseYourFoundationDatabaseInput(args?.requestContext.app.config.jsonSrc!);
};

/**
 * Use this function to call your action and process the results as needed
 */
async function action(input: FetchChooseYourFoundationDatabaseInput, ctx: Msdyn365.IActionContext): Promise<IDatabaseRow[]> {
    const res = await Msdyn365.sendRequest<any>(input.jsonSrc, 'get');
    const database = res.data;
    return database;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IDatabaseRow[]>>action,
    // Give your data action a unique id
    id: 'FetchChooseYourFoundationDatabase',
    input: createInput
    // Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
